import React from "react";
import "./projects_table.scss";
import SolarProject1 from "../../assets/img/accordian_operation/solar-project1.png";
import SolarProject2 from "../../assets/img/accordian_operation/solar-project2.png";
import SolarProject3 from "../../assets/img/accordian_operation/solar-project3.png";
import SolarProject4 from "../../assets/img/accordian_operation/solar-project4.png";
import SolarProject5 from "../../assets/img/accordian_operation/solar-project5.png";
import SolarProject6 from "../../assets/img/accordian_operation/solar-project6.png";
import SolarProject7 from "../../assets/img/accordian_operation/solar-project7.png";
import SolarProject8 from "../../assets/img/accordian_operation/solar-project8.png";
import SolarProject9 from "../../assets/img/accordian_operation/solar-project9.png";
import SolarProject10 from "../../assets/img/accordian_operation/solar-project10.png";
import SolarProject11 from "../../assets/img/accordian_operation/solar-project11.png";
import SolarProject12 from "../../assets/img/accordian_operation/solar-project12.png";
import SolarProject13 from "../../assets/img/accordian_operation/solar-project13.png";
import SolarProject14 from "../../assets/img/accordian_operation/solar-project14.png";
import chittorgarh from "../../assets/img/accordian_operation/chittorgarh.png";
import projects_img from "../../assets/img/projects_img.png";
import Solar_Ananthapuram from "../../assets/pdf/Offering and Projects/Solar_Ananthapuram.pdf";
import Solar_Bikaner from "../../assets/pdf/Offering and Projects/Solar_Bikaner.pdf";
import Solar_Chikodi from "../../assets/pdf/Offering and Projects/Solar_Chikodi.pdf";
import Solar_Nargund from "../../assets/pdf/Offering and Projects/Solar_Nargund.pdf";
import Solar_Pavagada from "../../assets/pdf/Offering and Projects/Solar_Pavagada.pdf";
import Solar_Tuticorin from "../../assets/pdf/Offering and Projects/Solar_Tuticorin.pdf";
import Solar_Bhadla from "../../assets/pdf/Offering and Projects/Solar_Bhadla.pdf";
import Solar_Chittorgarh from "../../assets/pdf/Offering and Projects/Solar_Chittorgarh.pdf";


const solarProjects = [
  { 
    "image": SolarProject1,
    "location": "Ananthpuram, AP",
    "link": Solar_Ananthapuram,
    "capacity": "250",
    "status": "Commissioned"
  }, {
    "image": SolarProject2,
    "location": "Bikaner, Rajasthan",
    "link": Solar_Bikaner,
    "capacity": "300",
    "status": "Commissioned"
  }, {
    "image": SolarProject3,
    "location": "Chikkodi, Karnataka",
    "link": Solar_Chikodi,
    "capacity": "20",
    "status": "Commissioned"
  }, {
    "image": SolarProject3,
    "location": "Nargund, Karnataka",
    "link": Solar_Nargund,
    "capacity": "20",
    "status": "Commissioned"
  }, {
    "image": SolarProject4,
    "location": "Pavagada, Karnataka",
    "link": Solar_Pavagada,
    "capacity": "300", 
    "status": "Commissioned"
  }, {
    "image": SolarProject5,
    "location": "Tuticorin, Tamil Nadu",
    "link": Solar_Tuticorin,
    "capacity": "100",
    "status": "Commissioned"
  }, {
    "image": SolarProject6,
    "location": "Bhadla Solar Park, Rajasthan",
    "link": Solar_Bhadla,
    "capacity": "50",
    "status": "Commissioned",
  }, {
    "image": chittorgarh,
    "location": "Chittorgarh, Rajasthan",
    "link": Solar_Chittorgarh,
    "capacity": "250",
    "status": "Commissioned",
  },
  {
    "image": SolarProject8 ,
    "location": "Bikaner 2, Rajasthan",
    "link": "",
    "capacity": "300",
    "status": "Commissioned"
  },
  {
    "image": SolarProject7,
    "location": "Kadapa Solar Park, AP",
    "link": "",
    "capacity": "250",
    "status": "Commissioned",
  }, {
    "image": SolarProject3,
    "location": "(IRPL) Pavagada, Karnataka",
    "link": "",
    "capacity": "500",
    "status": "Partially Commissioned",
  }
]

export const ProjectsAccordian = () => {
  return (
    <div>
      <section id={"projects"}>
        <div className="container">
          <div className="row text-center pos_relative">
            <center>
              <div className="title pt-4">
                <h4>Projects</h4>
              </div>
            </center>
          </div>

          <div className="table-responsive">
            <table className="table table-striped ">
              <thead>
                <tr className="tableRow">
                  <th>S.No</th>
                  <th>Project Image</th>
                  <th>Project Type</th>
                  <th>Location</th>
                  <th>Capacity (MW AC)</th>
                  <th>Project Status</th>
                </tr>
              </thead>
              <tbody>
                {
                  solarProjects.map((project, index) => (
                    <tr>
                    <td> {index + 1} </td>
                    <th>
                      <img src={project?.image} alt="" />
                    </th>
                    <th>Solar</th>
                    <td> 
                      {/* {
                      project?.link ?  <a href={project?.link}> { project?.location } </a> 
                      : <span> {project?.location} </span>
                      } */}
                        {project?.location}
                    </td>
                    <td> { project?.capacity } </td>
                    <td> { project?.status } </td>
                  </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProjectsAccordian;

